/* eslint-disable prettier */
/**
 * ZH SP file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: "清除全部",
	canvasOversight: "Canvas监督",
	oversight: "监督",
	canvasLabel: "Canvas",
	myProjects: "我的项目",
	otherProjects: "其他项目",
	priorProjects: "前期项目",
	completedProjects: "已完成项目",
	completedLabel: "已完成",
	createProject: "创建项目",
	rollForward: "前推",
	rollForwardLabel: "后推",
	rollForwardTitle: "前推项目",
	project: "项目",
	openProject: "未开始项目",
	manageUsers: "用户管理",
	rollForwardInstructionalText: "是否确定后推项目? <br>该操作可以在创建新项目时将已完成项目用作模板。以下信息将被后推：项目名称、组织图、集团和集团管理员。",
	isClientUserError: "您没有任何活跃项目。请联系被邀请加入项目的安永项目组成员。",
	activeProjects: "活跃项目",
	myActiveProjects: "我的活跃项目",
	otherActiveProjects: "其他活跃项目",
	myCompletedProjects: "我的已完成项目",
	myActiveProjectsPlaceholder: "你可访问此处所列的EY Canvas监督项目。选择项目名称，打开该项目或点击某一计数，了解详细信息。",
	deleteProject: "删除项目",
	deleteProjectModalText: "是否确定删除此项目？<br>该项目将从你的登录页删除，并且任何项目组成员都无法继续访问。",
	createButton: "创建项目",
	search: "搜索",
	searchEngagement: "搜索项目",
	searchEngagements: "搜索项目",
	searchEntitiesAndEngagements: "搜索实体和项目",
	searchClientList: "搜索客户名称",
	noDataFound: "没有可显示数据。",
	expand: "展开",
	collapse: "折叠",
	more: "更多",
	options: "选项",
	editProject: "编辑项目",
	manageTeam: "管理项目组",
	markAsCompleted: "标记为已完成",
	connectedTo: "连接至",
	connectedClients: "已关联客户",
	connectedToClients: (count) => `${count} ${count == 1 ? '客户' : '客户'}`,
	connectedToEngagements: (count) => `项目: ${count == 0 ? '无' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? '项目' : '项目'}`,
	connectToEngagements: (count) => `连接 ${count} ${count == 1 ? '项目' : '项目'}`,
	connectedToAccessGroups: (count) => `关联至 ${count} ${count == 1 ? '分组' : '分组'}`,
	connectToAccessGroups: (count) => `连接 ${count} ${count == 1 ? '分组' : '分组'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? '实体' : '实体'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? '视图' : '查看'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? '域' : '域'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? '视图' : '查看'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? '域' : '域'}`,
	engagement: "项目",
	engagementNameLabel: "项目名称",
	engagementPartnerLabel: "项目合伙人",
	partnerLabel: "合伙人",
	notInvited: "未邀请",
	clientNameLabel: "客户名称",
	client: "客户",
	codeLabel: "代码",
	idLabel: "ID",
	engagements: "项目",
	engagementsLabel: "项目",
	noResultsFound: "未找到结果。",
	submit: "提交",
	saveAndContinue: "保存并继续",
	savecontinue: "保存并继续",
	saveDraft: "保存草稿",
	closeLabel: "关闭",
	step1: "步骤1",
	step2: "步骤2",
	step3: "步骤3",
	step4: "步骤4",
	step5: "步骤5",
	adminsNoneLabel: "无",
	domainsAllLabel: "全部",
	adminsHeaderLabel: "管理员： ",
	domainsHeaderLabel: "域： ",
	moreCountLabel: '+ {0}',
	selectClient: "选择客户",
	createOrgChart: "创建组织结构图",
	connnectToCanvas: "连接至EY Canvas",
	viewSummary: "视图汇总",
	viewLabel: "视图",
	cancelLabel: "取消",
	required: "必填",
	filter: "筛选",
	filtersWarningMessage: "筛选条件超过限制。一次只能应用25项筛选条件。",
	back: "返回",
	save: "保存",
	saveClose: "保存并关闭",
	continue: "继续",
	finish: "完成",
	saveChanges: "保存变更",
	projectName: "项目名称",
	projectOwners: "项目负责人",
	addAnotherProjectOwner: "添加另一位项目负责人",
	duplicateOwnerAdded: "重复用户",
	step1InstructionHeader: "输入项目名称，添加其他项目负责人，然后从下面的列表中选择一个或多个客户以开始。",
	step1SubInstructionPart1: `您必须有访问客户的GIS、GFIS或Mercury代码或EY Canvas项目的权限，才能在下方查看客户的姓名。您在此步骤中选择的客户将决定哪些EY Canvas项目可关联到您的项目。要了解有关如何使用EY Canvas Oversight的更多資訊，请查看我们的{link}`,
	step2InstructionHeader: "为您的项目创建组织结构图。",
	step2SubInstructionPart1: "组织结构图应该反映出客户的业务管理流程。该组织结构图将用于汇总关联到你项目的EY Canvas项目的数据，以及管理内部和外部项目组成员的访问权限。",
	here: "此处",
	zoomIn: "放大",
	zoomOut: "缩小",
	expandAll: "全部展开",
	collapseAll: "全部折叠",
	addLabel: "添加",
	editLabel: "编辑",
	removeLabel: "移除",
	noRowsTemplateStringPart1: "您没有客户访问权限。点击",
	noRowsTemplateStringPart2: "了解更多关于如何获得访问权限。",
	noRowSelected: "至少选择一个客户并继续。",
	firstName: "名字",
	lastName: "姓氏",
	displayLanguage: "显示语言",
	numberFormat: "数字格式",
	dateFormat: "日期格式",
	timezone: "时区",
	theme: "主题",
	chooseDisplayTheme: "选择默认显示主题。",
	light: "浅色",
	dark: "深色",
	usersettings: "用户设置",
	userOptions: "用户选项",
	clearHoverText: "清空",
	noFiltersAvailable: "没有可用的筛选条件",
	dashboard: "仪表盘",
	milestones: "里程碑",
	activityFeed: "活动提要",
	keyEvents: "关键事项",
	keyEventCompletion: "关键事项完成情况",
	canvasClientPortal: "Canvas客户端",
	canvasClientPortalEy: "EY Canvas客户端",
	groupAudit: "集团审计",
	projectManagement: "项目管理",
	reporting: "报告",
	insights: "见解",
	groupRiskAssessment: "集团风险评估",
	internal: "内部",
	external: "外部",
	members: "成员",
	show: "显示",
	showDetails: "显示详细信息",
	showMore: "显示更多",
	showLess: "显示更少",
	clientName: "客户名称",
	clientsLabel: "客户",
	clientLabel: "客户",
	source: "来源",
	code: "编码",
	accessDelegatedBy: "授予访问权限委托的人员 ",
	returnToPreviousStep: "回到上一步",
	backButtonWarning: "如果返回上一步并做出更改，则可能会影响你在此步骤的进度。<br>选择<b>继续</b>返回上一步或选择<b>取消</b>继续当前步骤。",
	step1SubInstructionPart3: "当前步骤选择的客户会决定可以与您项目建立连接的EY Canvas项目。",
	step3InstructionHeader: "选择一个或多个EY Canvas项目，拖放至您组织结构图。",
	step3InstructionPara: "EY Canvas项目和您组织结构图上实体的连接决定EY Canvas数据如何在您项目仪表盘上进行汇总。",
	availableLabel: "可用",
	connectedLabel: "已连接",
	milestoneSummaryView: "里程碑——汇总视图",
	taskCompletionByMilestone: "任务里程碑完成情况",
	basedOnTaskCompletition: "基于任务完成情况",
	scopeAndStrategy: "范围和策略",
	execution: "执行",
	conclusion: "结论",
	step3ListDefaultMessage: "您在步骤1所选择的客户没有可用项目。请返回步骤1选择其他客户并继续。",
	addNewEngagementLabel: "添加新项目",
	selectedLabel: "已选定",
	moreText: "更多",
	connectLabel: "连接",
	connectEngagements: "已连接项目",
	connectToAnEngagement: "连接至项目并开始。",
	connectToAnAccessGroup: "没有已关联的小组。",
	tasks: "任务",
	organizationalChartHeading: "实体",
	groupAdministratorsLabel: "集团管理员",
	step4InstructionHeader: "为您的项目创建组，并将这些组与您组织结构图上的一个或多个实体建立连接。",
	step4ImportantNote: "重要注释：集团成员可以查看你与集团关联的组织图实体或该实体的子实体的EY Canvas项目数据。如果你将一个集团连接到组织结构图上的母实体，则该集团将能够查看母实体及其所有子实体的EY Canvas项目数据。",
	addAGroup: "添加小组",
	addGroup: "添加小组",
	searchGroup: "搜索小组",
	addNewGroupHeader: "在此创建新组。",
	editNewGroupHeader: "在此编辑现有集团。",
	addNewGroupInstruction: "项目创建后，你可以邀请内部和外部项目组成员加入该集团。你可以选择添加集团管理员，该管理员还可以邀请项目组成员加入该集团。",
	groupName: "小组名称",
	groupAdministrators: "小组管理员（可选）",
	groupAdministratorsSubHeading: "添加小组管理员。小组管理员有权在您项目创建后邀请其他成员加入该项目。小组管理员没有编辑小组视图和域名的权限。",
	clearAllValues: "清空",
	createGroupDashboardViews: "展示板视图",
	dashboardViewsSubHeading: "至少选择一个视图。视图决定项目组成员浏览项目仪表盘时可以看到的数据。",
	duplicateDomain: "域名重复",
	allMilestones: "全部里程碑",
	someMilestonesSelected: "已选择{0}个里程碑",
	noGroupsAdded: "没有为此项目添加域名。",
	step5InstructionHeader: "复核你的EY Canvas监督项目。",
	step5SubInstruction: "如需要进行修改，点击编辑图标返回上一步。<b>如对上一步内容做出修改，则将影响之后步骤的进度。</b>",
	associationNotRequired: "不需要关联",
	accessGroupAlreadyAddedToParent: "你已将一个或多个选择的小组关联至母公司。如果访问组已关联至母公司，则小组成员可以查看母公司及其所有子实体的EY Canvas项目数据。因此，不需要关联。",
	deleteGroupInstructionalText: "是否确认删除此分组？<br>删除不可恢复。小组成员不可再访问你的项目。",
	deleteGroup: "删除分组",
	removeMember: "删除成员",
	removeMemberTitle: "请确定是否删除该项目组成员？如果该项目组成员属于多个小组，则他们将从此处列出的所有小组中删除，并且可能无法再访问此项目。如果仅想将成员从某一个小组删除，则点击<b>编辑</b>选项。",
	teamMember: "项目组成员",
	clientNameLbl: "客户",
	help: "帮助",

	//Org char left rail
	filters: "筛选",
	countEngagementSelected: "已选择{1}个项目中的{0}个项目",
	of: "{num} of",
	entityName: "实体名称",
	enterEntityName: "在此输入实体名称",
	projectOwner: "项目所有者",
	role: "角色",
	domains: "域名（可选）",
	domainSubHeading: "如果邀请外部项目组成员加入该集团，请至少添加一个域名。域名指邮箱地址中@符号后的字符。如想添加外部项目组成员，要保证该成员有该集团的有效域名。",
	addAdministrator: "添加小组管理员",
	addNewDomain: "添加新域",
	addExistingDomain: "添加现有域名",
	placeholderStep3NoEngagementMessage: "您在步骤1所选择的客户没有可用项目。请返回步骤1选择其他客户，然后继续。",
	placeholderStep3NoConnectedEngagementMessage: "没有已连接的项目。",
	placeholderStep3AllEngagementsConnected: "所有可用项目已关联至你的项目。",
	placeholderStep4NoConnectedGroupMessage: "暂无关联的小组。",
	domainName: "域名",
	engagementLabel: "项目",
	start: "开始",
	end: "结束",
	suggestedEnd: "建议结束",
	status: "状态",
	thereIsNoDataToDisplay: "没有可显示数据。",
	selectadditionalEntitiesToContinue: "选择其他实体，然后继续。",
	comingSoonToDisplay: "组成部分状态将很快可获取。",
	checkForUpdatesToDisplay: "请在接下来的几周内返回检查更新。",
	userSearchPlaceholder: "输入姓名或邮箱，然后按回车键查看结果。",
	userSearchPlaceholderForExternal: "输入邮箱，然后按回车键查看结果。",
	partnerInChargeInvitedToTheEngagement: "被邀请加入该项目的审计负责合伙人",
	partnerInChargeSignedOffOnCraSummary: "签署综合风险评估汇总表的审计负责合伙人",
	eqrSignedOffOnCraSummary: "签署综合风险评估汇总表的项目质量复核人",
	partnerInChargeSignedOffOnAuditPlan: "签署审计计划的审计负责合伙人",
	picInvited: "已邀请PIC",
	picSignOffCRA: "综合风险评估的PIC签名",
	picSignOffAuditPlan: "审计计划的PIC签名",
	eqrSingOffCRA: "综合风险评估的EQR签名",
	overdue: "逾期",
	outOf: "之外",
	edit: "编辑",
	remove: "删除",
	add: "添加",
	admin: "管理员",
	views: "查看",
	domainLabel: "域",
	domainslabel: "域",
	viewLabelText: "查看",
	viewsLabelText: "查看",
	administrators: "管理员",
	none: "无",
	organizationChart: "组织图",
	invalidDomainName: "无效域名",
	lastRefreshed: "上次刷新",
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: "上次更新的调节数据",
	quickFilter: "快速筛选",
	notApplied: "未应用",
	quickFilterInput: "快速筛选名称",
	quickFilterSubHeaderText: "完成后，你可以应用快速筛选来优化要查看其数据的实体，而无需单独选择每个实体。",
	createFilterTrigger: "创建新筛选",
	createFilterTitle: "创建新快速筛选",
	createFilterButton: "创建快速筛选",
	createFilterHeaderText: "选择一个或多个组织图实体以创建快速筛选。",
	createFilterSubHeaderText: "完成后，你可以应用快速筛选来优化要查看其数据的实体，而无需单独选择每个实体。",
	editFilterTitle: "编辑快速筛选",
	editFilterHeaderText: "编辑或删除快速筛选",
	editFilterIconTitleTip: "编辑",
	oneRequired: "至少选择一个。",
	noFiltersCreatedTitle: "尚未创建快速筛选。",
	noFiltersCreatedSubTitle: "创建快速筛选，然后开始。",
	clear: "清空",
	completionRange: "完成范围",
	engagementCount: "项目数",
	clickOnAVisualBelowToFilterTheEngagementList: "点击下方可视窗口筛选项目列表。",
	organizationalChartTooltip: "选择“组织结构图”，以编辑或移除Oversight Project中的实体。",
	organizationalChart: "组织结构图",

	//Task status chart labels
	open: "打开",
	inProgress: "进行中",
	inReview: "复核中",
	completeUpperCase: "完成",
	taskStatusOverdue: "逾期",
	noDataForSelections: "您的选择没有可用数据。",
	selectOneOrMoreMilestones: "选择一个或多个不同里程碑，然后继续。",
	milestoneDetailTitle: "里程碑——详细信息",
	taskStatusByMilestone: "任务里程碑状态",
	milestoneDetailSubtitle: "基于任务状态",
	basedOnAllTasksForTheSelectedMilestone: "根据已选择里程碑的所有任务",
	totalTasks: "总任务",
	noneSelected: "无选择",
	nameOrEmail: "姓名或邮箱",
	remove: "删除",
	milestonesTooltipText: "审计进度（按里程碑确定）",
	canvasClientPortalTooltipText: "请求状态，包括即将到期、逾期和已退回项目。",
	groudAuditTooltipText: "主审小组和组成部分项目小组状态，包括已退回请求和逾期请求",
	projectManagementTooltipText: "复核注释和工作分配的状态（包括逾期项）。该视图对客户不可见。",
	insightsTootipText: "主审小组和组成部分项目小组的风险、实质性程序、控制策略和发现的比较该视图对客户不可见。",
	reportTootipText: "各国的报告准备情况、修改和任务完成状态",
	taskStatusComplete: "任务状态-完成",
	taskStatusInreview: "任务状态-复核中",
	taskStatusInprogress: "任务状态-进行中",
	taskStatusOpen: "任务状态-未开始",

	//Review Notes chart labels
	reviewNotesByStatusTitle: "所有复核注释",
	byStatus: "按状态",
	totalNotes: "注释汇总",
	totalNotesLabel: "注释汇总",
	openNotes: "未解决注释",
	byPriority: "按优先级别",
	cleared: "已清除",
	closed: "已关闭",
	low: "低",
	medium: "中等",
	high: "高",
	critical: "重要",
	notesTableTooltipContent: "基于未解决状态的注释",

	// Group audit
	groupAuditTotalForms: "表格汇总",
	groupAuditNotSent: "未发送",
	groupAuditUnlinked: "未关联",
	totalTasksCapitalized: "任务汇总",
	primary: "主要",
	component: "组成部分",

	//Bar chart
	are: "为",
	complete: "完成",
	noMilestoneDataForSelection: "此审计阶段没有可显示的里程碑数据。",
	selectDifferentAuditPhase: "选择其他审计阶段或选择其他实体，然后继续。",

	//Delegate
	delegateInstruction: "向你项目组的其他成员授予访问权限，使其有资格代表你创建项目。输入项目组成员姓名或邮箱地址以开始。你的委托人有权访问您的所有客户。",

	delegateAccess: "管理委托人",
	addAnother: "添加其他委托人",
	hideMyDelegate: "隐藏我的委托人",
	showMyDelegate: "显示我的委托人",
	noRecord: "未找到结果",
	duplicateUser: "已添加委托人",
	duplicateUserMessage: "已添加过该用户",
	addDelegates: "添加委托人",
	delegateTo: "接受委托人",
	delegateFrom: "授予委托人",
	delegateToMsg: "你尚未将访问权限委托给任何项目组成员。",
	delegateFromMsg: "尚无项目组成员将访问权限委托给你。",

	// Project dashboard left rail
	searchFilterPlaceholder: "搜索筛选",
	searchEntitiesPlaceholder: "搜索实体",
	outOfEngagements: "<b>{1}</b>个项目中的<b>{0}</b>个",
	engagementCompletedBasedOnTaskCompletion: "根据任务完成情况，<b>{0}</b>项目<b>{1}</b>已完成",
	engagementsCompletedBasedOnTaskCompletion: "根据任务完成情况，<b>{0}</b>个项目已完成<b>{1}</b>个。",
	engagementCompletedBasedOnTaskCompletionReporting: "<b>{0}</b>个项目共完成<b>{1}</b>个任务。",
	engagementsCompletedBasedOnTaskCompletionReporting: "<b>{0}</b>个项目共完成<b>{1}</b>个任务。",
	engagementCompletedBasedOnTaskCompletionMilestone: "就该里程碑而言，<b>{0}</b>个项目共完成<b>{1}</b>个任务。",
	engagementsCompletedBasedOnTaskCompletionMilestone: "就该里程碑而言，<b>{0}</b>个项目共完成<b>{1}</b>个任务。",
	reportReleaseDate: "报告发布日期",
	partnerInvited: "受邀合伙人",
	picSignoffOnCra: "签署综合风险评估的审计负责复核人",
	eqrSignoffOnCra: "签署综合风险评估的项目质量复核人",
	picSignoffOnAuditPlan: "签署审计计划的审计负责合伙人",
	overdueLabel: "逾期",

	//Team members
	teamMembersTitle: "项目组成员",
	membersTitle: "成员",
	eyContactsTitle: "安永联系人",
	allMembersLabel: "所有成员",
	internalMembersLabel: "内部成员",
	externalMembersLabel: "外部成员",
	groupsTitle: "我的分组",
	projectOwnersTitle: "项目负责人",
	projectOwnersLabel: "项目所有者",
	projectOwnerLabel: "项目所有者",

	//CCP
	summary: "汇总",
	requestsByStatus: "按状态排列请求",
	totalRequests: "总请求",
	totalRequestsTitle: "请求汇总",
	receivedByEy: "安永已收到",
	acceptedByEy: "安永已接收",
	outstandingByEy: "未完成",
	returned: "已退回",
	receivedByEyOnTime: "安永按时接收",
	averageDaysOverdue: "平均预期天数",
	outOfReceivedAndAccepted: "收到并接受了<b>{1}</b>中<b>{0}</b>个请求",
	outOfStandingRequests: "<b>{1}</b>中<b>{0}</b>个请求逾期",
	outOfAverageDaysOverdue: "<b>{1}</b>中<b>{0}</b>个请求逾期",
	draftRequests: "{0}请求草稿",
	noResultMessageHeader: "没有可显示的数据。选择其他实体，然后继续。",
	noResultMessageSubHeader: '',
	members: "成员",
	memberLabel: "成员",
	adminLabel: "管理员",
	projectOwnerLabel: "项目负责人",
	viewsLabel: "查看",
	metrics: "指标",
	yes: "是",
	no: "否",
	emptyMessageAvailableGroup: "尚无分组创建标签。<br>点击<b>添加分组</b>开始。",
	thereIsNoDataToDisplayForThisEntity: "此实体没有可显示数据。",
	typeLabel: "类型",
	groupsLabel: "分组",
	group: "分组",
	entitiesLabels: "实体",
	entityLabel: "实体",
	nameLabel: "名称",
	searchTeamMembers: "搜索项目组成员",
	notSelectedLabel: "未选中",
	entitiesLabel: "实体",
	noDataAvailableLabel: "无可用数据。",
	delete: "删除",
	deleted: "已删除",
	addAMember: "添加成员",
	addMemberHeaderText: "为你项目的一个或多个小组添加新成员。",
	teamMemberInformation: "项目组成员信息",
	teamMemberNote: "输入你希望添加至选定小组的内部或外部项目组成员的姓名或邮箱。按回车键查看结果。",
	selectGroupNote: "至少选择一个分组。小组成员可以查看其小组所关联的所有组织结构图实体以及这些实体的任何子实体的 EY Canvas项目与数据。",
	inviteAndClose: "邀请并关闭",
	inviteAndAddAnother: "邀请并添加另一个",
	contacts: "联系人",
	email: "邮箱",
	emailAll: "向所有人发送邮件",
	contactTeam: "联系项目组",
	emptyMessage: "此项目没有可用的联系人。",
	comingDue: "即将到期",
	tomorrow: "明天",
	next3days: "未来3天",
	next5days: "未来5天",
	next10days: "未来10天",
	next30days: "未来30天",
	comingDueNext5days: "将在5天后到期",
	entityDetails: "实体详细信息",
	requestsByEntity: "按实体排列请求",
	basedOnTheSelectedCategory: "根据已选择类别",
	requestCount: "请求数",
	selectedDay: "选择的天数",
	editMember: "编辑成员",
	editMemberHeaderText: "编辑所选项目组成员有权访问的组。",
	editaGroup: "编辑分组",
	editAGroupHere: "在此编辑分组",
	selectAnotherFrame: "选择其他时间段以查看数据。",
	emptyFrameShort: "选择其他实体以继续。",
	emptyFrame: "选择其他实体或不同时间段继续。",
	editMemberHeaderText: "编辑所选项目组成员有权访问的组。",
	confirm: "确定",
	markCompleteModalInstrTextPart1: "是否确认完成该项目？",
	markCompleteModalInstrTextPart2: "完成此操作后无法撤消。可以前推已完成项目，在创建新项目时用作模板。",
	firstPage: "首页",
	lastPage: "最后一页",
	nextPage: "下一页",
	prevPage: "上一页",

	// Add Tag
	keyContacts: "关键联系人",
	customTags: "自定义标签",

	// Manage Tags
	manageTagInstructional: "在此创建新定制标签。您还可以编辑和删除已有的定制标签。标签联系人可帮助您灵活管理EY Canvas Oversight项目中的联系人。",
	emptyCustomTagsList: "尚未创建任何定制标签。",
	manageTagTitle: "管理定制标签",
	manageTagLinkButton: "管理标签",
	color: "颜色",
	tagName: "名称",
	tagDelete: "删除",
	tagCreate: "创建新标签",
	customTagsHeader: "定制标签",

	//preparer assignment tile
	totalPreparerAssignments: "编制人分配工作汇总",
	inprogress: "进行中",
	preparerAssignments: "编制人分配工作",
	byAssignmentStatus: "按分配工作状态",
	taskWithoutPreparerAssignments: "没有分配编制人的任务",
	tasksWithoutPreparerAssignments: "没有分配编制人的任务",
	preparerFilterTitle: "编制人",

	// reviewer assignment tile
	totalReviewerAssignments: "复核人分配工作汇总",
	taskWithoutReviewerAssignments: "没有分配复核人 的任务",
	tasksWithoutReviewerAssignments: "没有分配复核人 的任务",
	reviewerFilterTitle: "复核人",

	assignments: "工作分配",
	notes: "注释",
	preparerNotAssigned: "未分配编制人",
	reviewerAssignments: "复核人分配",
	reviewerNotAssigned: "未分配复核人",
	basedOnPreparerAssignments: "基于编制人分配",
	basedOnPreparerAssignmentsOpenAndInProgress: "基于打开和进行中状态的编制人分配",
	basedOnReviewerAssignments: "基于复核人分配",
	basedOnReviewerAssignmentsOpenAndInProgress: "基于打开和进行中状态的编制人分配",

	statusOpen: "状态-未开始",
	statusInProgress: "状态-进行中",
	statusClosed: "状态-已关闭",
	byPriorityLow: "按优先级别-低",
	byPriotityMedium: "按优先级别-中",
	byPriorityHigh: "按优先级别-高",
	byPriorityCritical: "按优先级别-关键",

	findingsLabel: "发现",
	riskLabel: "风险",
	digitalAuditLabel: "数字审计",
	digitalAuditStrategy: "数字化审计策略",
	byDigitalAuditTypeLabel: "按数字审计策略",
	basedOnProfileSelection: "根据配置文档选择情况",
	basedOnSelectionArchiveForm: "根据归档表格的选择情况",
	MisstatementsByType: "错报（按类型）",
	DeficienciesBySeverity: "缺陷（按严重程度）",
	MisstatementsLabel: "错报",
	DeficienciesLabel: "缺陷",
	primarTeamDeficiencyHeader: "主审小组- {0}",
	componentRegionalTeamDeficiencyHeader: "地区和组成部分审计小组- {0}",
	auditTileHeaderTextPrimary: "主审小组- {0}",
	componentRegionalTeamHeader: "地区和组成部分审计小组- {0}",
	allTeamDeficiencyHeader: "所有项目- {0}",
	primarTeamMisstatementHeader: "主审小组- {0}",
	componentRegionalTeamMisstatementHeader: "地区和组成部分审计小组- {0}",
	allTeamMisstatementHeader: "所有项目- {0}",
	deficiencyLabel: "缺陷",
	inherenRisktLabel: "重大错报风险",
	significantRiskLabel: "重大",
	fraudRiskLabel: "舞弊",
	significantDeficiencyLabel: "重要缺陷",
	materialWeaknessLabel: "重大缺陷",
	factualLabel: "事实错报",
	projectedLabel: "推断错报",
	judgmentalLabel: "判断性错报",
	reclassificationLabel: "重新分类",
	totalDeficiencyLabel: "缺陷汇总",
	totalRiskLabel: "风险汇总",
	totalRisksLabel: "风险汇总",
	totalDeficienciesLabel: "缺陷汇总",
	totalMisstatementLabel: "错报汇总",
	totalMisstatementsLabel: "错报汇总",
	allEngagementHeader: "所有项目- {0}",
	noAuditSightGroupData: "<b>没有可显示的集团审计数据。</b><br> 点击切换开关中的<b>所有</b>查看汇总数据。",
	noAuditTileDataPlaceholder: "没有可显示数据。选择其他实体以继续。",
	openReviewNotes: "未解决复核注释",
	byPriorityLevel: "按优先级别",
	risks: "风险",
	groupRoleLabel: "小组角色",
	totalRisks: "风险汇总",
	byType: "按类型",
	inherent: "重大错报风险",
	significant: "重大",
	fraud: "舞弊",
	strategy: "策略",
	notApplicable: "不适用",
	customizableTable: "定制表格",
	selectUpToOptionHeader: "最多选择{0}选项",
	selectUpToThreeOptionHeader: "最多选择三个选项 ",
	selectUpToFourOptionHeader: "最多选择四个选项",
	psps: "PSP",
	osps: "OSP",
	hxpsps: "HxPSP",
	totalSubstantiveProcedures: "实质性程序汇总",
	totalSubstantiveProcedure: "实质性程序汇总",
	totalITControls: " ITGC和ITSP汇总",
	totalITControl: "ITGC和ITSP汇总",
	testing: "测试",
	nonTesting: "不测试",
	auditStrategy: "审计策略",
	totalControls: "控制汇总",
	totalControl: "控制汇总",
	removeProject: "删除项目",
	removeProjectInstructionalText: "是否确定从活跃项目列表中删除以下项目？<br>如删除，将无法继续访问。",
	substantiveProcedures: "实质性",
	controls: "控制",
	itlabel: "IT",

	//delegates removed
	userDelTitle: "我的委托人",
	delTitleDetail: "你已将访问权限委托给此处列出的项目组成员。你的委托人有权访问你有权访问的所有客户。",
	delElseMsg: "你尚未添加任何委托人。",
	delegateTitle: "删除委托人",
	delegateMember: "已委托",
	deleteMessage: "是否确定删除此委托人吗？<br/>删除后，他们将无法再代表你创建项目。",

	//Advanced filters.
	advancedFilters: "高级筛选条件",
	selectAll: "选择全部",
	deselectAll: "取消选择全部",
	applyFilters: "应用筛选条件",
	region: "地区",
	country: "国家",
	city: "城市",
	state: "州",
	advancedFiltersInstructionalText: "选择你要查看其项目数据的实体。",
	advancedFiltersInstructionalTextLine2: "你无权访问的实体显示为无法访问。如需要访问权限，请联系小组管理员。",
	engagementsSelected: "已选项目",
	filterYes: "是",
	filterNo: "否",

	//Group Audit
	pendingResponse: "待回应",
	primaryTileTitle: "主审小组状态",
	reportingFormStatus: "报告表格状态",
	reportingForm: "报告表格",
	summarizedForPrimaryTeams: "为主审小组汇总",
	primaryTileSubtitle: "已发送集团报告表格",
	received: "已接收",
	dueToPrimaryTeam: "应发送至主审小组",
	sentToPrimaryTeam: "已发送至主审小组",
	evidencePending: "待定证据",
	evidenceComplete: "已完成证据",
	componentTileTitle: "组成部分项目小组状态",
	componentTaskStatus: "组成部分任务状态",
	componentTask: "组成部分任务",
	comingsoonTaskStatus: "即将到来",
	summarizedForComponentTeams: "为组成部分项目小组汇总",
	componentTileSubtitle: "已收到集团审计任务",
	unlinkedTask: "未关联任务",
	unlinkedTasks: "未关联任务",

	//Group Risk Assessment
	groupRiskAssessmentTitle: "风险",
	groupRiskSummaryTitle: "集团风险评估",

	// Reporting
	reportModifications: "报告修改",
	byReportType: "按报告类型",
	notSelected: "未选中",
	unmodified: "无保留",
	modified: "非标准",
	reports: "报告",
	opinions: "意见",
	modifiedReports: "非标准意见",
	modifiedOpinions: "非标准意见",
	adverse: "否定意见",
	disclaimer: "无法表示意见",
	qualification: "保留意见",
	qualified: "保留意见",
	engagementReportTooltip: "此处仅汇总报告日期为当前日期或更早的项目。所有项目见下表。",
	geography: "地点",
	standars: "准则",
	gaap: "公认会计原则",
	gaapUs: "美国公认会计原则",
	ifrs: "国际财务报告准则",
	other: "其他",
	yearEndDate: "年度结束日",
	endDateOfPeriodCovered: "涵盖期间结束日",
	reportDate: "报告日",
	archiveDeadline: "归档截止日",
	reportType: "报告类型",
	opinionType: "意见类型",
	taskStatus: "任务状态",
	exportData: "导出数据",
	exportToExcel: "导出",
	orgChartEntity: "组织图实体",
	engagementId: "项目ID",
	contactName: "联系人姓名",
	contactEmail: "联系人邮箱",
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: "按照类型——特别风险",
	statusFraud: "按照类型——舞弊风险",
	substantivePSPs: "实质性-PSP",
	substantiveOSPs: "实质性-OSP",
	substantiveHxPSPs: "实质性-HxPSP",
	controlsTesting: "控制-测试",
	controlsNonTesting: "控制-非测试",
	iTTesting: "IT-测试",
	iTNonTesting: "IT-非测试",
	misstatementsFactual: "错报-事实",
	misstatementsProjected: "错报-推断",
	misstatementsJudgmental: "错报-判断性",
	misstatementsReclassification: "错报-重分类",
	deficienciesDeficiency: "缺陷-缺陷",
	deficienciesSignificantdeficiency: "缺陷-重要缺陷",
	deficienciesMaterialweakness: "缺陷-重大缺陷",
	statusComplete: "状态-完成",
	statusInReview: "状态-复核中",
	statusInProgress: "状态-进行中",
	statusOpen: "状态-未开始",
	statusNotSent: "状态-未发送",
	statusReturned: "状态-已退回",
	statusDocumentationPending: "状态-待完成文档记录",
	statusDocumentationComplete: "状态-已完成文档记录",
	statusReceivedbyEY: "状态-安永已收到",
	statusAcceptedbyEY: "状态-安永已接收",
	statusOutstanding: "状态-逾期",
	noCompletedProjectsMessagePart1: "你没有任何已完成项目。",
	noCompletedProjectsMessagePart2: "如果你是项目负责人，则可以将项目标记为已完成。可以后推已完成项目，在创建新项目时用作模板。",
	noCompletedProjectsMessage: "你没有任何已完成项目。<br />如果你是项目负责人，则可以将项目标记为已完成。可后推已完成项目，在创建新项目时用作模板。",
	requests: "请求",

	//Reporting readiness report
	week: "每周",
	weeks: "每周",
	readinessReportTitle: "报告准备情况",
	taskCompletionByEngagement: "各项目的任务完成情况",
	readinessLegendTitle: "距离报告日期",
	basedOnReportDateProximityForEachEngagement: "根据各项目报告日临近情况",

	//ReportCompletion
	taskCompletionStatus: "任务完成状态",
	taskCompletionByLocation: "各位置的任务完成情况",
	basedOnCompletedTasksForEachEngagement: "根据各项目的已完成任务",
	byGeography: "按地点",
	taskCompletion: "任务完成情况",
	completedTasks: "已完成任务",

	engagementArchived: "该项目已被归档。数据不再可获得。",
	externalUsersNoActiveProjMessage: "你没有任何活跃项目。请联系安永项目组成员获取访问权限。",

	//Error Messages
	networkErrorMessage: "应用程序网络出现错误。刷新页面，稍后再试。如果错误仍然存在，请联系帮助台。",
	genericErrorMessage: "目前不能完成所选择操作。刷新页面，然后重试。如果错误仍然存在，请联系帮助台。",
	otherProjectPlaceholder: "你的EY Canvas项目已关联至此处列示的EY Canvas监督项目。你没有访问此项目的权限。与项目负责人或集团管理员沟通获取访问权限。",
	noProjectsAvailable: "无可用项目。",
	completedProjectPlaceholder: "此处列示了你已完成的EY Canvas监督项目。选择<b>后推</b>选项<br>，在创建新项目时将已完成项目用作模板。",
	completedNotProjectPlaceholder: "你没有任何已完成项目。<br>如果你是项目负责人，则可以将项目标记为已完成。可后推已完成项目，在创建新项目时用作模板。",

	//Log out and time out modal
	logoutModalTitle: "为保护你账户的安全，登录将自动注销",
	sessionTimerMsgLine1: "由于长时间未进行操作，你当前的工作会话即将自动结束。",
	sessionTimerMsgLine2: "为了你的使用安全起见，EY Canvas监督会话将在你在系统中不操作时间到达30分钟后自动结束。",
	sessionTimerMsgLine3: "当前会话将在{0}分钟后自动退出。",
	sessionTimerMsgLine4: "如果你希望继续保持登录状态，请点击",
	modalContinueButton: "<b>继续</b>",
	modalLogoutButton: "注销",
	modalCloseButton: "关闭",
	countryNotAvailable: "不适用的国家",
	regionNotAvailable: "不可用地区",
	notAvailable: "不可用",
	signout: "注销",
	engagementTypeNotAvailable: "项目类型不可用",

	// Admin portal
	administration: "管理员",
	mainPageInstructionalText: "欢迎访问EY Canvas监督管理员页面",
	manageProjectsFormatted: "管理<br />项目",
	manageUsersFomatted: "管理<br />用户",
	manageAdminsFormatted: "管理<br />监督管理员",
	homeLabel: "主页",
	userNotFoundError: "没有找到用户。",
	manageUsersInstructionalText: "输入用户GUI搜索用户",
	selectRole: "选择角色",
	role: "角色",

	//Manage User
	manageUsersTitle: "用户管理",
	otherProjectsTabTitle: "其他项目",
	validGuiErrorMsg: "输入有效GUI",
	accessibleProjects: "可访问项目",
	delegates: "委托人",
	projectID: "项目ID",
	projectStatus: "项目状态",
	gui: "GUI",
	emailAddress: "邮件地址",
	userRole: "用户角色",
	userID: "用户ID",
	noResultMessage: "没有匹配搜索条件的结果。",
	noResultFound: "没有找到记录。",
	userDetails: "用户详细信息",
	active: "活跃",
	inActive: "非活跃",
	manageAdmins: "管理EY Canvas监督管理员",
	manageAdminsInstructionalText: "下方列出了所有EY Canvas监督管理员。你可以编辑管理员角色，添加和删除管理员。",
	adminReader: "应用程序读取权限管理员",
	adminWriter: "应用程序写入权限管理员",
	superAdmin: "应用程序超级管理员",
	revertChanges: "撤回变动",
	unSavedChanges: "未保存变动",
	unSavedChangesMessage: "你有未保存变动，如选择继续，变动将丢失。<br/>点击<b>确认</b>继续。点击<b>取消</b>，返回到相关页面并保存你的变动。",
	addNewAdmin: "添加新管理员",
	addEYContactInstructions: "输入姓名或电子邮件地址，然后按回车键查看结果。选择一个角色，添加新的监督管理员。",

	// ManageProjects
	orgChartEntities: "组织图实体",
	manageProjectsInstructionalText: "输入项目ID搜索项目。",
	projectDetails: "项目详细信息",
	parentEntity: "父实体",
	connectedGroups: "关联集团",
	validProjectIDError: "输入有效的项目ID",
	addNewMember: "添加成员",
	adminAddMemberInstructionalText: "搜索用户并选择添加用户的分组。",
	currentApplication: "当前应用",

	//Software Update
	softwareUpdate: "软件更新",
	updateNow: "立即更新",
	updateMsg: "EY Canvas Oversight有可用的软件更新。选择立即更新，下载并安装更新。页面将被刷新。",

	//ContactDB
	placeholderForSearch: "搜索",
	contactClearAll: "清除全部",
	contactShowMoreFilters: "更多",
	contactListFilter: "访问联系人列表",
	dashboardAccessFilter: "访问展示板",
	groupRoleFilter: "小组角色",
	tagFilter: "标签",
	countryFilter: "国家",
	serviceLineFilter: "业务线",
	typeFilter: "类型",
	roleFilter: "角色",
	dashboardAccess: "展示板访问",
	contactList: "联系人列表",
	noEntitiesMessage1: "没有可显示数据。",
	noEntitiesMessage2: "选择其他实体以继续。",
	noContacts: "此实体没有联系人。",
	engagementsContacts: "项目",
	manuallyAdded: "手动添加",
	dashboardViews: "查看",
	columnName: "姓名",
	columnEmail: "电子邮件",
	columnEngagement: "项目",
	columnType: "类型",
	columnRole: "角色",
	columnServiceLine: "业务线",
	columnDashboard: "访问展示板",
	columnDashboardView: "展示板视图",
	columnContactList: "访问联系人列表",
	columnTags: "标签",
	columnEntity: "实体",
	noResults: "未发现结果",
	noResultsAvailable: "没有可用数据。",
	searchContacts: "搜索联系人",
	selectedContacts: "已选联系人",
	tag: "标签",
	manageAccess: "管理访问权限",
	formLengthMessage: "文本不得超过{number}个字符。",
	viewMoreColumns: "查看更多列",
	projectOwnerBadge: "项目所有者",
	entityAdminBadge: "实体管理员",
	eyTeam: "安永团队",
	clientTeam: "客户团队",
	userProfile: "用户资料",
	columnGroupRiskAssessment: "进入集团风险评估",
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: "添加联系人",
	toolbarAccessLog: "访问日志",
	toolbarMessageLog: "消息日志",
	toolbarCustomizeTable: "定制表格",
	toolbarExportData: "导出数据",
	toolbarManageAccess: "管理访问权限",
	toolbarDefineAttributes: "定义属性",
	toolbarGenerateMessage: "生成信息",
	toolbarTags: "标签",
	toolbarRemove: "移除",

	//ContactDB - Add Contact Modal
	addContactLabel: "添加联系人",
	addContactTitle: "添加联系人",
	addContactInstructional: "在EY Canvas Oversight项目中添加一个或多个联系人。如果你要添加的联系人需要访问展示板或联系人列表，你可在此处授予他们访问权限。",
	columnEntities: "实体",
	noEntities: "无",
	duplicatedUser: "已被添加为联系人。您可以在联系人列表上管理他们的访问权限。",
	accessToDashboard: "访问展示板",
	dashBoardsViews: "展示板访问权限和视图",
	placeholderEntities: "实体",
	placeholderAccess: "访问",
	placeholderAttributes: "属性",
	placeholderTags: "标签",
	projectOwnerAccessLabel: "项目负责人访问权限",
	entityAdminAccessLabel: "实体管理员访问权限",
	accessToContactListLabel: "访问联系人列表",
	saveContactLabel: "保存",
	cancelContactLabel: "取消",
	noContactsAdded: "尚未添加联系人。",
	noCustomColumns: "没有为您的项目创建的自定义标签。",
	toggleContactYes: "是",
	toggleContactNo: "否",
	mustSelectOneEntity: "您必须选择至少一个实体以继续。",
	mustSelectOneView: "对于您授予EY Canvas Oversight展示板访问权限的所有联系人，选择至少一个视图。",
	mustBeOnwerOrAdministrator: "您必须成为项目所有者或实体管理员才可进行此操作。更新所选实体以继续。",
	cannotEditAccessForProjectOwners: "您不能编辑对项目所有者的访问权限： {list}",
	attributesLabel: "属性",
	externalUserDomainMismatch: "域未得到一个或多个选定实体的许可。请在实体设置流程中添加必需的域，然后重试。",
	projectOwnerAccessToogleInfo: "项目负责人拥有EY Oversight项目的所有权限。",
	entityAdminAccessToogleInfo: "实体管理员有特定于实体的权限，可以根据需要执行管理任务。",

	//ContactDB-CustomizeTable Modal
	customizeTableModal: "自定义表格",
	InstructionalTextCustomizeTableModal: "选择要查看的列。",
	cancelCustomizeTable: "取消",
	saveCustomizeTable: "保存",
	tooltipCustomizeTable: "自定义表格",
	standardColumns: "标准列",
	customColumns: "自定义列",
	closeTitleModal: "关闭",
	addCustomColumn: "添加自定义列",
	editCustomColum: "编辑自定义列",
	addCustomColumnLegend: "自定义列允许您获取和管理联系人的其他属性。您最多可为您的项目创建5个自定义列。创建自定义列后，您可以选择一个或多个联系人并定义属性。如果删除自定义列，联系人的属性也将被删除。",
	deleteCustomColumnLegend: "点击<b>删除</b>图标，删除自定义列。如继续，您的项目将无法使用该自定义列。您之前应用于联系人的所有属性也将同时删除。",
	customColumnName: "列名称",
	attribute: "属性",
	attributes1to5: "属性（1-5）",
	visibleToExternal: "对外部联系人可见",
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: "筛选",
	searchTitletip: "搜索",
	addExternalContactColumnName: "名称",
	addExternalContactColumnDomain: "域",
	confirmDomain: "确认域",

	//ContactDB - Profile Modal
	profileModalTitle: "配置文件",
	profileModalAccessSection: "访问",
	profileModalCustomAttributesSection: "自定义属性",
	profileModalDashboardSection: "展示板视图",

	//ContactDB - Generate Message
	selectMessageRecipients: "选择消息接收人",
	notification: "通知",
	generateMessage: "生成消息",
	gmInstructionalText: "向您选择的联系人发送邮件或通知。通知只能发送给内部联系人。邮件可以发送给内部联系人和外部联系人。",
	messageType: "消息类型",
	messageRecipient: "消息接收人",
	selectContactsNow: "现在选择联系人",
	useSelectedContacts: "使用选定联系人",
	moreFilters: "+更多筛选条件",
	countries: "国家",
	groupRoles: "小组角色",
	groupRole: "分组角色",
	roles: "角色",
	role: "角色",
	serviceLines: "业务线",
	serviceLine: "业务线",
	contatcs: "联系人",
	singularContact: "联系人",
	singularEngagement: "项目",
	allContact: "所有联系人",
	allEntitles: "所有实体",
	allCountries: "所有国家",
	allGroupRoles: "所有小组角色",
	allEngagements: "所有项目",
	allServicesLines: "所有业务线",
	allRoles: "所有角色",
	subject: "主题",
	removeTooltip: "移除",
	fromEntity: "来自实体",
	fromEngagement: "来自项目",
	notificationMessage: "通知消息",
	linkLabel: "链接标签（可选）",
	link: "链接（可选）",
	fromEntityNotification: "来自实体",
	mustSelectOne: "你必须选择至少一位联系人以继续。",
	emailSentMsg: "已向所选联系人生成电子邮件。",
	notificationSentMsg: "已向所选联系人发送通知。",
	messageFrom: "消息来自",
	duplicateMessage: "复制消息",
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: "复核你的实体发送的邮件列表。如果你需要发送后续消息，你可以选择复制先前的消息。",
	messageLogTitle: "消息日志",
	today: "今日",
	yesterday: "昨日",
	thisWeek: "本周",
	lastWeek: "上周",
	twoWeeksAgo: "两周前",
	older: "更早",
	notificationTo: "发送通知至",
	emailTo: "发送电子邮件至",
	sentBy: "发送人",
	from: "从",
	date: "日期",
	time: "时间",
	subject: "主题",
	multiContatcsLowerCase: "联系人",
	singleContactLowerCase: "联系人",
	seeMore: "查看更多",
	seeLess: "查看更少",
	messageLogEmptyMessage: "尚未发送消息。",
	messageLogFileExported: "消息记录",
	typeColumnToExportToExcel: "类型",
	sentByColumnToExportToExcel: "发送人",
	fromColumnToExportToExcel: "始于",
	dateColumnToExportToExcel: "日期",
	timeColumnToExportToExcel: "时间",
	subjectColumnToExportToExcel: "主题",
	contactsColumnToExportToExcel: "联系人",
	emailExportToExcel: "邮件",
	notificationExportToExcel: "通知",

	//ContactDB - Access Log
	accessLog: "访问日志",
	accessLogInstructional: "复核下方列出的项目组成员，确定是否将他们作为联系人添加或移除。",
	addAll: "添加所有",
	removeAll: "移除所有",
	ignoreAll: "忽略所有",
	contactsToAddEmpty: "目前没有潜在联系人需要添加。",
	contactsToRemoveEmpty: "目前没有潜在联系人需要移除。",
	ignore: "忽略",
	addAllConfirmationModal: "一个或多个用户的域未得到实体许可。点击继续将用户添加至联系人列表。域将被导入并添加至实体许可的域清单。",
	addConfirmationModal: "用户的域未得到实体许可。点击继续将用户添加至联系人列表。域将被导入并添加至实体许可的域清单。",

	// ContactDB - Message Log - Filter
	messageTypeFilter: "消息类型",
	sentByFilter: "发送人",
	fromEntityFilter: "来自实体",
	toEntityFilter: "发送至实体",
	toCountryFilter: "发送至国家",
	toGroupRoleFilter: "发送至小组角色",
	toEngagementFilter: "发送至项目",
	toServiceLineFilter: "发送至业务线",
	toRoleFilter: "发送至角色",

	//ContactDB - Define Attributes
	defineAttributes: "定义属性",

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: "添加其他实体管理员",
	editEntity: "编辑实体",
	entityAdministrators: "实体管理员（可选）",
	editEntityAdministratorsInstruction: "你可以选择添加一个或多个实体管理员。他们可以向该实体添加联系人，并提供对EY Canvas Oversight模块的访问权限。",
	editEntityDomainInstruction: "外部项目组成员必须有此实体的有效域才能访问EY Canvas Oversight。系统将在设置向导的第4步从关联的EY Canvas项目导入批准的域。如果计划邀请其他外部项目组成员加入此实体，请添加一个或多个域。域是指电子邮件地址中@符号后面的字符。",
	level: "级别{0}",

	// ContactDB Remove Contacts
	removeIcon: "移除",
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: "是否确定从项目中移除这些联系人？如果这些联系人属于多个实体，将从所有实体中移除他们。如果您需要从单个实体中移除一位联系人，请选择该联系人以编辑其访问权限。",
	removeSelectedContacts: "已选择的联系人",

	domainNotPermitted: "有一位或多位实体管理员的域对于该实体不允许使用。",
	listView: "列表视图",
	cardView: "卡片视图",

	recordsNotAvailable: "记录不可用",

	// Project Layout Update
	welcomeLabel: "欢迎",
	activeProjectsInstructionalText: "您有权访问此处列出的EY Canvas Oversight项目。选择一个模块以前往该模块，或者点击数字以查看您每个项目的详细信息。",
	otherProjectsInstructionalText: "您的EY Canvas项目已关联至此处列出的EY Canvas Oversight项目。您没有访问这些项目的权限。请联系项目所有者或实体管理员取得访问权限。",
	completedProjectsInstructionalText: "您已经完成的EY Canvas Oversight项目列在此处。创建新项目时选择<b>后推</b>选项，将您已完成的项目用作模板。",
	goToLabel: "前往",
	entityAdmins: "实体管理员",
	entityAdmin: "实体管理员",
	keyContacts: "主要联系人",
	keyContact: "主要联系人",
	contactListLabel: "联系人列表",
	draftlabel: "初稿",
	projectWizard: "项目向导",
	noEntityAdminsAdded: "没有关联的实体管理员",
	addProjectOwner: "添加项目所有者",
	addProjectOwnerInstrText: "使用用户姓名或邮箱搜索用户，以将其添加为所选项目的项目所有者。",
	projectSummary: "项目汇总",
	privacyNotice: "隐私通知",
	groupOversightProject: "集团监督项目（新！）",
	groupOversightProjectTooltip: "在<b>集团监督项目</b>中，您可以看到您的主审和/或地区EY Canvas项目，并为其创建安永监督项目。在设置安永监督项目时，您的EY Canvas集团结构中的地区和/或组成部分EY Canvas项目将<b>自动</b>填充。<br><br>此外，这些类型的项目将可以访问集团风险评估模块，在该模块中可以查看主审、地区和/或组成部分项目的风险评估活动。",
	oversightProject: "监督项目（法定审计）",
	oversightProjectTooltip: "在监督项目（法定审计）中，您可以手动选择您的客户以及与您相关联的EY Canvas项目，为其创建安永监督项目。",

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: "本EY Oversight项目不涉及集团风险评估活动。",
	engagementData: "项目数据",
	engagementDetails: "项目详情",
	reconciliations: "对账",
	nextComponent: "下一个组成部分",
	prevComponent: "上一个组成部分",
	allAccounts: "所有账户",
	generateEmail: "生成电子邮件",
	reconciliationDetailInstructional: "以下信息汇总了主审小组EY Canvas集团结构中与组成部分项目小组关联的所有账户和风险。应将账户和风险映射到组成部分项目小组EY Canvas项目中的同等账户和风险。",
	primaryTeamAccountName: "'主审小组账户名称",
	componentTeamAccountName: "组成部分项目小组账户名称",
	designation: "指定",
	openAccounts: "未结账户",
	componentTeamAccounts: "组成部分项目小组账户",
	mapAccountsMessage: "每个主审小组账户应至少有一个匹配的组成部分项目小组账户。点击{button}开始。",
	primaryTeamAccountStatus: "主审小组账户状态",
	totalAccounts: "账户总数",
	assessedAccounts: "已评估账户",
	primaryTeamRiskStatus: "主审小组风险状态",
	openRisks: "敞口风险",
	assessedRisks: "已评估风险",
	totalRisks: "风险汇总",
	primaryTeamRiskDesignationAndName: "主审小组风险指定和名称",
	primaryTeamAccountsRelatedToRisk: "与风险相关的主审小组账户",
	componentTeamRisksAndRelatedAccounts: "组成部分项目小组风险和相关账户",
	relateRisks: "关联风险",
	relateRisksMessage: "每个主审小组账户应至少有一个映射的组成部分项目小组风险。{button}然后开始。",
	pspIndexesHeader: "PSP",
	pspIndexes: "主要实质性程序索引",
	markAssessed: "标记为已评估",
	markReOpen: "重新打开",
	riskMarkAssessedMessage: "查看相关的主审小组和组成部分项目小组风险。有完整的映射后，{button}。",
	riskMarkOpenMessage: "如果需要对已标记为已评估的风险进行更改，请{button}该风险。此风险分组将显示在“未关联风险”视图中。",
	markAssessedSuccessMessage: "已成功将相关账户标记为已评估。要查看账户，请转到已评估视图。",
	reopenAssessedAccount: "重新打开",
	reopenAssessedAccountMessage: "如果需要对已标记为已评估的账户进行更改，请{button}该账户。该账户分组将出现在“未完成范围”中。",
	reopenSuccessMessage: "已成功重新打开相关账户。要查看账户，请转到未完成视图。",
	teamAccountMappedMessage: "查看已映射的主审小组账户和组成部分项目小组账户。有完整的映射后，{button}。",
	teamAccountWasPreviousAssessedMessage: 'This primary and component team account grouping was previously marked assessed but there were changes to the account(s). Review primary and component team accounts to ensure the mapping is still correct. Once complete, {button}.',
	createComment: "创建批注",
	editComment: "编辑批注",
	commentTitle: "批注",
	createCommentInstructionalText: "输入所选账户或风险的批注详细資訊，然后点击“儲存”以完成。",
	editCommentInstructionalText: "编辑所选账户或风险的批注详细資訊，然后点击“儲存”完成。",
	lastModified: "上次修改时间：",
	addComment: "添加批注",
	accountDescription: "选择“未关联账户”以查看尚未与组成部分项目小组账户关联并标记为已评估的主审小组账户。选择已评估的账户以查看已评估的主审小组账户。",
	riskDescription: "选择“未关联风险”以查看尚未与组成部分项目小组风险关联并标记为已评估的主审小组风险。选择已评估风险以查看已评估的主审小组风险。",
	successAssessedMessage: "相关风险已成功标记为已评估。要查看风险，请转到已评估的视图。",
	successReOpenMessage: "相关风险已成功重新打开。要查看风险，请转到未完成视图。",

	// Relate risks modal
	relateRisksModalTitle: "将组成部分项目小组风险与主审小组风险相关联",
	relateRisksModalInstructionalText: "选择下面的组成部分项目小组风险以与所选主审小组风险相关联。",
	primaryRegionTeamRisk: "主审小组风险：",
	primaryTeamRiskLabel: "主审小组风险",
	thereIsNoDataToDisplayForThisSelection: "没有可显示数据，无法选择。",
	accountAndAsssociated: "账户和关联主要实质性程序",
	disabledRegionComponentTeamRiskLabel: "此组成部分项目小组风险已對應到另一个主审小组风险。一个组成部分项目小组风险只能對應到一个主审小组风险。为相关的主要风险选择“关联风险”以取消该风险的关联（如适用）。",
	selectOneOrMore: "选择一个或多个",

	relateAccountsModalTitle: "将组成部分项目小组账户与主审小组账户相关联",
	relateAccountName: "主审小组账户：",
	relateAccountpspIndex: "主审小组主要实质性程序索引：",
	relateAccountpspIndexes: "主审小组主要实质性程序索引：",
	relateAccountInstructionalText: "选择下面的组成部分项目小组账户以与所选主审小组账户相关联。",
	pspIndexcountLabel: "与主审小组/地区小组账户相关的主要实质性程序索引",
	relateAccounts: "关联账户",

	viewComponentTeamAccountsText: "查看组成部分项目小组账户",
	componentTeamAccountsModalTitle: "组成部分项目小组账户未关联和/或不适用",
	componentTeamAccountsModalInstructionalText: "组成部分项目小组账户应与主审小组账户相关联。返回相关页面以关联账户。如果组成部分项目小组账户不适用于集团审计，则将该账户标记为“不适用”。",
	componentTeamAccountsModalNotApplicableInstructionalText: "不适用的组成部分项目小组账户以这种方式标记，因为它们不适用于集团审计。如果下面错误地列出了某个账户，请将该账户移回“未关联”，以便将该账户与主审小组账户相关联。",
	notRelatedTab: "未关联",
	notApplicableTab: "不适用",
	unmapped: "未對應",
	unrelate: "取消关联",
	action: "操作",
	notApplicableActionTitletip: "选择“取消关联”将风险移动到“未关联”选项卡。“未关联”的风险应与主审小组风险相关联。如果风险不适用于集团审计，则标记为“不适用”。",
	notRelatedActionTitletip: "选择“不适用”将风险移至“不适用”选项卡。“不适用”的组成部分项目小组风险不适用于集团审计。",

	higherInheritRisk: "较高固有风险",
	lowerInheritRisk: "较低固有风险",
	riskAssociated: "相关风险",
	riskAssociatedHigher: "与较高固有风险相关并导致较高固有风险的风险",

	viewComponentTeamRisks: "查看组成部分项目小组风险",
	unmappedRisksModalTitle: "组成部分项目小组风险不相关和/或不适用",
	unmappedRisksModalInstructional: "组成部分项目小组风险应与主审小组风险相关联。返回相关页面以关联风险。如果组成部分项目小组风险不适用于集团审计，则将该风险标记为“不适用”。",
	notApplicableRisksModalInstructional: "不适用的组成部分项目小组风险以这种方式标记，因为它们不适用于集团审计。如果下面错误地列出了某个风险，请将该风险移回“未关联”，以便将该风险与主审小组风险相关联。",
	added: "已新增",
};

export const temporaryLabels = {
	dryDock: "Drydock",
	darkMode: "深色模式",
	dashboard: "仪表盘",
	projects: "项目",
	scopeStrategy: "范围和策略",
	accountSummary: "账户汇总表",
	scotSummary: "SCOT汇总表",
	craSummary: "CRA汇总表",
	itSummary: "IT汇总表",
	SPSummary: "实质性评估汇总表",
	auditPlan: "审计计划",
	conclusion: "结论",
	findings: "发现",
	changesReport: "报告日后的修改",
	teamMember: "项目组成员独立性",
	archiveChecklist: "归档核对表",
	enagagementmanagement: "项目管理",
	integration: "整合",
	guidedWorkflow: "工作流指导",
	copyrightMessage: "版权©<年份>。版权所有"
};

export const createGRAProjectLabels = {
	creationInstructional: "输入项目名称， 然后从下面的列表中选择一个主要或区域EY Canvas项目， 以创建安永监督项目。 < br > 根据所选项目， 在EY Canvas集团结构中识别的EY Canvas项目将被自动填充， 作为项目设置的一部分。 点击 {link}了解有关EY Canvas Oversight的更多信息。",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: "搜索EY Canvas项目名称、ID或客户名称",
	noAccessToEng: "您无权访问任何EY Canvas项目。",
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: "请至少选择一个项目进行保存。",
	userGuideLinkText: "用户指引"
};

export const deleteCommentModalLabels = {
	titleText: "删除批注",
	instructionalText: "是否确认删除该批注？",
	triggerText: "删除",
	confirmLabel: "确认",
	cancelLabel: "取消",
	closeLabel: "关闭"
}

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: "主要"
},
{
	id: GARoleTypeId.Region,
	label: "地区"
},
{
	id: GARoleTypeId.Component,
	label: "组成部分"
}
];

export const engagementTableLabels = {
	engagementName: "项目名称",
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: "项目创建日期",
	GAComponentCreated: "已添加的组成部分",
	GAComponentRemoved: "已删除的组成部分",
	GAComponentUnlinked: "未链接的组成部分",
	AccountAdded: "已添加的账户",
	AccountRemoved: "已删除的账户",
	AccountDesignationChanged: "已更改的账户指定",
	AccountEstimateChanged: "已更改的账户估计",
	AccountExecutionTypeChanged: "已更改的账户执行类型",
	AssertionAssociated: "已关联的认定",
	AssertionUnassociated: "未关联的认定",
	AssertionInherentRiskChanged: "固有风险变化",
	AssertionControlRiskDesignationChanged: "控制风险指定变更",
	RiskCreated: "已创建的风险",
	RiskRemoved: "已删除的风险",
	RiskAssociated: "已关联的风险",
	RiskUnassociated: "未关联的风险"
};

export const activityTableLabels = {
	sourceEngagement: "源项目",
	activityType: "活动类型",
	objectImpacted: "受影响的对象",
	relatedObjectImpacted: "受影响的相关对象",
	relatedSecondaryObjectImpacted: "受影响的相关次级对象",
	activityDate: "活动日期"
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: "组成部分项目小组风险名称",
	details: "详细資訊",
};

export const riskTypes = [{
	id: '1',
	label: "特别风险",
},
{
	id: '2',
	label: "舞弊风险",
},
{
	id: '3',
	label: "固有风险"
}
];

export const engagementLabels = {
	accountName: "账户/披露名称",
	accountTypeName: "指定",
	canvasEngagementId: "项目ID",
	controlRiskTypeName: "控制风险",
	engagementDescription: "项目名称",
	inherentRiskTypeName: "固有风险",
	assertionName: "认定",
	pspIndexTitle: "主要实质性程序索引",
	riskName: "风险名称",
	riskTypeName: "风险类型",
	relatedTasks: "关联的任务",
	taskStatus: "任务状态",
	controlRiskAssessment: "控制风险评估"
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: "此表單没有可显示的数据。",
	unselectedEntities: "该EY Oversight项目没有调节数据。将组成部分与主审小组EY Canvas项目中的集团指引流中的账户相关联，以便在此处显示调节数据。",
	columns: {
		components: "组成部分",
		open: "未完成",
		assessed: "已评估",
		total: "合计"
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: "组成部分项目小组账户",
		pspIndexes: "主要实质性程序索引",
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "此组成部分项目小组账户已對應到另一个主审小组账户。一个组成部分项目小组账户只能對應到一个主审小组账户。为相关主要账户选择“关联账户”以取消该账户的关联（如适用）。",
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: "主要实质性程序索引",
		notRelated: {
			actionColumnName: labels.action,
			titleTip: "将账户标记为\'不适用\'会将账户移动到\'不适用\'选项卡。如果账户不适用于集团审计，则应标记为\'不适用\'。",
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: "选择\'取消关联\'将账户移动到“未关联”选项卡。“未关联”的账户应与主审小组账户相关联。如果账户不适用于集团审计，则应标记为“不适用”。",
			actionLabel: labels.unrelate
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "组成部分项目小组风险",
	actions: "操作"
};

export const AdminUserErrors = {
	userError: "没有找到用户。"
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "你没有执行此操作的权限。"
};

export const Errors = {
	106: "你没有执行此操作的权限。",
	107: "你没有执行此操作的权限。",
	111: "你不能将访问权限委托给自己。",
	112: "未找到用户。",
	310: "未找到项目。",
	314: "该分组不允许使用针对一个或多个小组管理员的域。",
	316: "你必须成为项目负责人或集团管理员才可添加项目组成员。与项目负责人沟通获取访问权限。",
	317: "仅内部成员才能被添加为项目负责人。以下为外部用户：{0}。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
	318: "以下分组不得使用针对{0}的域：{1}",
	319: "该项目已由其他项目负责人完成。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
	321: "你必须成为项目负责人才可完成此操作。与项目负责人沟通获取访问权限。",
	323: "此分组已被另一个项目组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
	324: "你必须成为项目负责人才可完成此操作。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
	325: "你必须成为项目负责人或集团管理员才可进行变动。与项目负责人沟通获取访问权限。",
	326: "完成所有必填信息栏并保存项目。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
	327: "项目已保存",
	328: "你尝试添加的小组成员已经是该组成员。请刷新页面并重试。",
	330: "仅剩一位项目负责人，不可删除",
	331: "一个或以上分组已被另一个项目组成员删除。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
	332: "至少需要一位项目负责人。你不能将自己移出项目。",
	341: "你没有访问选定客户或项目的权限。",
	343: "你只能删除活跃项目和草稿状态的项目。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
	344: "你必须成为项目负责人才可删除此项目。请刷新页面并重试。如果错误仍然存在，请联系帮助台。",
	345: "此项目已被另一个项目小组成员删除。请刷新页面并重试。如错误仍然存在，请联系帮助台。",
	346: "另一个项目所有者或实体管理员已经复核了{0}的访问权限。请刷新访问日志并重试。",
	347: "您必须是项目所有者或实体管理员才能添加或从此项目中移除联系人。与项目所有者沟通请求访问权限。",
	348: "您仅能从您管理的实体中移除联系人。以下联系人属于您不担任其管理员的实体，因此无法移除：{0}。",
	360: "您必须成为该项目所有者才可完成此操作。",
	361: "您必须是项目所有者或实体管理员才能执行该操作。请联系项目所有者取得访问权限。",
	362: "您只能管理属于您管理的实体的联系人的访问权限。以下联系人所属实体并非由您管理，无法编辑其访问权限：{0}。",
	364: "您正尝试编辑一个或多个已从该项目中删除的联系人的访问权限。请刷新页面并重试。",
	365: "您正试图编辑已从此项目中删除的一个或多个联系人的属性：{0}请刷新页面并重试。",
	366: "您只能编辑属于您管理的实体的联系人的属性。以下联系人属于不是由您管理的实体：{0}",
	367: "您当前编辑的自定义列已被其他项目组成员删除。请刷新页面并重试。",
	368: "您当前编辑的自定义列已被其他项目组成员删除。请刷新页面并重试。",
	369: "您必须成为项目所有者才可完成此操作。",
	370: "您只能编辑属于您管理的实体的联系人的属性。以下联系人属于非您管理的实体：{0}",
	372: "您必须成为该项目所有者才可执行此操作。",
	373: "无法从联系人列表页删除项目负责人。前往项目向导执行所请求的操作。",
	374: "您是项目负责人，不能将自己从此项目中删除。",
	375: "您不能从项目中删除最后一个项目负责人。必须至少保留一名项目负责人。",
	376: "您必须是项目负责人才可从项目中添加/删除项目负责人或实体管理员。无法删除以下联系人：{0}",
	378: "无法删除域，因为此监督项目联系人列表页上的联系人正在使用该域。请转到联系人列表页，删除该域的联系人，然后返回此处删除该域。",
	502: "获取项目指令失败。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
	503: "你没有访问选定客户的权限。",
	601: "获取客户指令失败。刷新页面，然后重试。如错误仍然存在，请联系帮助台。",
	1605: "所选用户已存在。",

	1803: "执行标签操作的项目数据无效，请刷新页面并重试。如果问题仍然存在，请联系帮助台获取更多帮助。",
    1804: "您必须成为该项目的项目所有者才可执行此标签操作。",
	1901: "发送消息API指令失败。",
	1902: "消息不能为空。",
	1903: "允许的消息长度为200个字符。",
	1904: "允许的回调文本长度为50个字符。",
	1905: "允许的回调uri长度为50个字符。",
	1906: "你必须选择至少一个筛选条件以继续。",
	1907: "收件人不能重复。",
	1908: "项目不能为空。",
	1909: "消息类型不是有效值。",
	1910: "接收人不能为空。",
	1911: "消息不能为空。",
	1912: "接收人类型不是有效值。",
	1913: "你没有发送通知的适当权限。请联系项目负责人或实体管理员以请求访问权限。",
	1914: "只能向内部联系人发送通知。复核邮件接收人并删除外部联系人以继续。",
	2101: "安永政策的授权、批准和通知服务暂不可用。我们无法确认是否所有相关政策均已完成。如您尚未复核相关政策，请刷新页面并重试。如果问题仍然存在，请联系帮助台。",

	// Reconciliation
	2701: "获取所有调节指令失败。",
	2702: "无效的请求。",
	2703: "按ID获取调节指令失败。",
	2704: "按ID获取风险指令失败。",
	2705: "在数据库中找不到项目。",
	2706: "在数据库中找不到账户。",
	2707: "在数据库中找不到项目。",
	2708: "创建项目批注指令失败。",
	2709: "已创建批注。请更新页面并重试。",
	2710: "修补集团组成部分账户指令失败。",
	2711: "在数据库中找不到集团组成部分账户。",
	2712: "理由批注不能为空。",
	2713: "理由批注不能超过4000个字符。",
	2714: "未找到集团组成部分风险。",
	2715: "未找到集团组成部分。",
	2718: "更新调节指令失败",
	2720: "此项目已被其他用户编辑或删除。请更新并重试。",
	2721: "已创建批注。请更新页面并重试。",
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: "至少向组织结构图连接一个项目，然后继续。",
	ErrorAtleastOneGroupAssociationRequired: "至少向组织结构图连接一个分组，然后继续。",
	ErrorStep2DataNotComplete: "为组织结构图上的每个实体输入名称，然后继续。"
};

export const engagementsViewBy = [{
	id: 0,
	label: "全部",
	value: "全部"
},
{
	id: 1,
	label: "按国家",
	value: "国家",
	groupAttributeName: 'countryName'
},
{
	id: 2,
	label: "按主要事务所",
	value: "按地区",
	groupAttributeName: 'regionName'
},
{
	id: 3,
	label: "按项目类型",
	value: "类型",
	groupAttributeName: 'profileNature'
}
];

export const milestones = [{
	id: 1,
	label: "范围",
	auditPhaseId: 1,
	value: 1
},
{
	id: 2,
	label: "策略",
	auditPhaseId: 1,
	value: 2
},
{
	id: 3,
	label: "穿行测试",
	auditPhaseId: 2,
	value: 3
},
{
	id: 4,
	label: "中期控制测试",
	auditPhaseId: 2,
	value: 4
},
{
	id: 5,
	label: "中期实质性测试",
	auditPhaseId: 2,
	value: 5
},
{
	id: 6,
	label: "穿行测试（年末流程）",
	auditPhaseId: 2,
	value: 6
},
{
	id: 7,
	label: "年末控制测试",
	auditPhaseId: 2,
	value: 7
},
{
	id: 8,
	label: "年末实质性测试",
	auditPhaseId: 2,
	value: 8
},
{
	id: 9,
	label: "结论",
	auditPhaseId: 3,
	value: 9
},
{
	id: 10,
	label: "不适用",
	auditPhaseId: 2,
	value: 10
},
{
	id: 11,
	label: "执行",
	auditPhaseId: 2,
	value: 11
},
{
	id: 12,
	label: "范围和策略质量活动",
	auditPhaseId: 1,
	value: 12
},
{
	id: 13,
	label: "其他范围和策略",
	auditPhaseId: 1,
	value: 13
},
{
	id: 14,
	label: "综合风险评估",
	auditPhaseId: 1,
	value: 14
},
{
	id: 15,
	label: "风险评估和重要性水平",
	auditPhaseId: 1,
	value: 15
},
{
	id: 16,
	label: "最终确定范围和策略",
	auditPhaseId: 1,
	value: 16
},
{
	id: 17,
	label: "预审后项目管理",
	auditPhaseId: 2,
	value: 17
}
];

export const daysOptions = [{
	id: daySelection.tomorrow,
	value: daySelection.tomorrow,
	label: "明天"
},
{
	id: daySelection.next3days,
	value: daySelection.next3days,
	label: "未来3天"
},
{
	id: daySelection.next5days,
	value: daySelection.next5days,
	label: "未来5天"
},
{
	id: daySelection.next10days,
	value: daySelection.next10days,
	label: "未来10天"
},
{
	id: daySelection.next30days,
	value: daySelection.next30days,
	label: "未来30天"
}
];

export const auditPhases = [{
	id: 1,
	label: "范围和策略"
},
{
	id: 2,
	label: "执行"
},
{
	id: 3,
	label: "结论"
}
];

export const findings = [{
	id: 1,
	label: "错报",
	subTitle: "错报（按类型）"
},
{
	id: 2,
	label: "缺陷",
	subTitle: "缺陷（按严重程度）"
}
];
export const risks = [{
	id: 1,
	label: '',
	subTitle: "按类型"
}];

export const auditStrategies = [{
	id: 1,
	label: "实质性",
	subTitle: "实质性程序（按类型）"
},
{
	id: 2,
	label: "控制",
	subTitle: "控制（按测试策略）"
},
{
	id: 3,
	label: "IT",
	subTitle: "IT程序（按测试策略）"
}
];

export const auditInsights = [{
	id: 1,
	label: "按分组角色"
},
{
	id: 2,
	label: "全部"
}
];

export const projectStatus = {
	Active: "活跃",
	Draft: "草稿",
	Cancel: "取消",
	Complete: "已完成",
	Delete: "删除"
};

export const ProjectStatusLabels = [{
	label: "首字母缩写",
	id: 1,
	value: 'Initial'
},
{
	label: "草稿",
	id: 2,
	value: 'Draft'
},
{
	label: "活跃",
	id: 3,
	value: 'Active'
},
{
	label: "取消",
	id: 4,
	value: 'Cancelled'
},
{
	label: "已完成",
	id: 5,
	value: 'Completed'
},
{
	label: "删除",
	id: 6,
	value: 'Delete'
}
];

export const projectTeamEngagementTableGroup = [{
	id: 1,
	label: "编制人分配"
},
{
	id: 2,
	label: "复核人分配"
}
];

export const archiveReportQualifiedType = [{
	id: archiveReportQualifiedTypeId.notSelected,
	label: "未选中"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
	label: "无保留意见——有强调事项"
},
{
	id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
	label: "无保留意见——无强调事项"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
	label: "保留意见——有强调事项"
},
{
	id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
	label: "保留意见——无强调事项"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
	label: "否定意见——有强调事项"
},
{
	id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
	label: "否定意见——无强调事项"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
	label: "无法表示意见——有强调事项"
},
{
	id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
	label: "无法表示意见——无强调事项"
}
];

export const strategyTableGroup = [{
	id: 1,
	label: ''
}];

export const roleForMember = [{
	id: roles.partnerInCharge,
	label: "审计负责合伙人",
	roleAbbreviation: "PTR IN CHG"
},
{
	id: roles.engagementPartner,
	label: "项目合伙人",
	roleAbbreviation: "EP"
},
{
	id: roles.executiveDirector,
	label: "执行总监",
	roleAbbreviation: "EXEC DIR"
},
{
	id: roles.principal,
	label: "负责人",
	roleAbbreviation: "PRINCIPAL"
},
{
	id: roles.seniorManager,
	label: "高级经理",
	roleAbbreviation: "SR.MANAGER"
},
{
	id: roles.manager,
	label: "经理",
	roleAbbreviation: "MANAGER"
},
{
	id: roles.senior,
	label: "高级审计员",
	roleAbbreviation: "SENIOR"
},
{
	id: roles.staff,
	label: "审计员",
	roleAbbreviation: "STAFF"
},
{
	id: roles.intern,
	label: "实习生",
	roleAbbreviation: "Intrn"
},
{
	id: roles.engagementQualityReviewer,
	label: "项目质量复核人",
	roleAbbreviation: "EQR"
},
{
	id: roles.otherPartner,
	label: "其他合伙人",
	roleAbbreviation: "OTHER PTR"
},
{
	id: roles.gdsStaff,
	label: "GDS——审计员",
	roleAbbreviation: "GDS——STAFF"
},
{
	id: roles.advisory,
	label: "咨询（ITRA、TAS、人力资本或其他）",
	roleAbbreviation: "ADV"
},
{
	id: roles.tax,
	label: "税务",
	roleAbbreviation: "Tax"
},
{
	id: roles.executiveSupportServices,
	label: "管理支持服务",
	roleAbbreviation: "ESS"
},
{
	id: roles.generalCounsel,
	label: "法务",
	roleAbbreviation: "GCO"
},
{
	id: roles.auditQualityReviewer,
	label: "审计质量复核人",
	roleAbbreviation: "AQR"
},
{
	id: roles.mlComponentTeam,
	label: "跨地区组成部分项目小组",
	roleAbbreviation: "MCT"
},
{
	id: roles.clientSupervisor,
	label: "客户主管",
	roleAbbreviation: "ClntS"
},
{
	id: roles.clientStaff,
	label: "客户助理",
	roleAbbreviation: "ClntSt"
},
{
	id: roles.internalAuditSupervisor,
	label: "内部审计主管",
	roleAbbreviation: "IASup"
},
{
	id: roles.internalAuditStaff,
	label: "内部审计员",
	roleAbbreviation: "IASt"
},
{
	id: roles.regulator,
	label: "监管机构",
	roleAbbreviation: "Reglr"
},
{
	id: roles.other,
	label: "其他（如，尽职复核）",
	roleAbbreviation: "Otrs"
},
{
	id: roles.office,
	label: "办公室",
	roleAbbreviation: "Off"
},
{
	id: roles.area,
	label: "地区",
	roleAbbreviation: "Area"
},
{
	id: roles.industry,
	label: "行业",
	roleAbbreviation: "IND"
},
{
	id: roles.national,
	label: "国际",
	roleAbbreviation: "NAT"
},
{
	id: roles.global,
	label: "全球",
	roleAbbreviation: "GBL"
},
{
	id: roles.gsdSenior,
	label: "GDS-高级审计员",
	roleAbbreviation: "GDS-SENIOR"
},
{
	id: roles.gsdManager,
	label: "GDS-经理",
	roleAbbreviation: "GDS-MANAGER"
}
];

export const toggleCCPEntityOptions = [{
	id: toggleCCPEntityDetail.comingDue,
	label: labels.comingDue
},
{
	id: toggleCCPEntityDetail.overdue,
	label: labels.taskStatusOverdue
},
{
	id: toggleCCPEntityDetail.returned,
	label: labels.returned
}
];


export const reportReadinessSeries = [{
	id: readinessReportCategories.comingDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.comingDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDueUnder1Week,
	label: `< 1{break}${labels.week}`
},
{
	id: readinessReportCategories.overDue12Weeks,
	label: `1-2{break}${labels.weeks}`
},
{
	id: readinessReportCategories.overDueOver2Weeks,
	label: `> 2{break}${labels.weeks}`
}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: "财务报表审计",
	[natureOfEngagements.integratedStatements.id]: "财务报表和财务报告内部控制整合审计",
	[natureOfEngagements.reviewStatements.id]: "中期财务报表审阅",
	[natureOfEngagements.nonAuditAccount.id]: "具有账户/认定/重大交易类别功能的非审计项目",
	[natureOfEngagements.nonAuditWorkPlan.id]: "仅具有工作计划功能的非审计项目"
};

export const AdminRoles = [{
	label: "应用程序读取权限管理员",
	id: 1
},
{
	label: "应用程序写入权限管理员",
	id: 2
},
{
	label: "应用程序超级管理员",
	id: 3
}
];

export const userType = [{
	value: 1,
	label: "内部"
},
{
	value: 2,
	label: "外部"
}
];

export const MessageType = [{
	value: 1,
	label: "邮件"
},
{
	value: 2,
	label: "通知"
}
];

export const groupRole = [{
	value: 1,
	label: "主审小组",
	id: 1,
	selected: false,
	disabled: false
},
{
	value: 2,
	label: "地区小组",
	id: 2,
	selected: false,
	disabled: false
}, {
	value: 3,
	label: "组成部分项目小组",
	id: 3,
	selected: false,
	disabled: false
},
{
	value: 4,
	label: "向非安永审计师报告的组成部分项目小组",
	id: 4,
	selected: false,
	disabled: false
},
{
	value: 5,
	label: "不适用",
	id: 5,
	selected: false,
	disabled: false
}
];

export const accessLogResource = [{
	id: 1,
	label: "需要添加的联系人"
},
{
	id: 2,
	label: "需要移除的联系人"
}
]

export const addContactsTabsResource = [{
	id: 1,
	label: "访问"
},
{
	id: 2,
	label: "属性"
},
{
	id: 3,
	label: "标签"
}
]

export const tags = [{
	name: "审计合伙人",
	id: 'auditPartner'
},
{
	name: "审计项目经理",
	id: 'auditEngagementManager'
}, {
	name: "GDS项目经理",
	id: 'gdsEngagementManager'
}, {
	name: "税务合伙人",
	id: 'taxPartner'
}, {
	name: "税务项目经理",
	id: 'taxEngagementManager'
}, {
	name: "FAIT合伙人",
	id: 'faitPartner'
}, {
	name: "FAIT项目经理",
	id: 'faitEngagementManager'
}, {
	name: "咨询合伙人",
	id: 'advisoryPartner'
}, {
	name: "咨询项目经理",
	id: 'advisoryEngagementManager'
}, {
	name: "专家",
	id: 'specialist'
}, {
	name: "客户管理员",
	id: 'clientadministrator'
}
];

export const dashboardContactViews = [{
	id: dashboardTabId.milestones,
	value: dashboardViewsConstants.milestones,
	tooltipText: "审计进度（基于里程碑）",
	key: "里程碑",
	checked: false
},
{
	id: dashboardTabId.projectManagement,
	value: dashboardViewsConstants.projectManagement,
	tooltipText: "复核注释和任务分配的状态，包括逾期的项目。无法授予外部用户访问项目管理展示板的权限。",
	key: "项目管理",
	checked: false,
},
{
	id: dashboardTabId.groupAudit,
	value: dashboardViewsConstants.groupAudit,
	tooltipText: "主审和组成部分项目小组状态，包括已退回和逾期项。",
	key: "集团审计",
	checked: false,
},
{
	id: dashboardTabId.groupRiskAssessment,
	value: dashboardViewsConstants.groupRiskAssessment,
	tooltipText: "主审小组和组成部分项目小组的集团风险评估视图。此视图客户不可查看。",
	key: "集团风险评估",
	checked: false
},
{
	id: dashboardTabId.canvasClientPortal,
	value: dashboardViewsConstants.ccp,
	tooltipText: "请求状态，包括已将到期、已逾期和已退回项。",
	key: "EY Canvas客户端",
	checked: false
},
{
	id: dashboardTabId.insights,
	value: dashboardViewsConstants.insights,
	tooltipText: "主审小组和组成部分项目小组间风险、实质性程序、控制策略和发现的比较。无法授予外部用户访问洞察展示板的权限。",
	key: "洞察",
	checked: false
},
{
	id: dashboardTabId.reporting,
	value: dashboardViewsConstants.reporting,
	tooltipText: "按国家分类的报告准备情况、修改和任务完成状态。",
	key: "报告",
	checked: false
}
];

export const colorOptionsLabels = {
	red: "红色",
	orange: "橙色",
	teal: "青色",
	blue: "蓝色",
	purple: "紫色",
	green: "绿色",
	yellow: "黄色",
	gray: "灰色"
};

export const exportToExcelLabels = {
	yes: "是",
	no: "否",
	exportData: labels.exportData,
	exportButtonTitle: "针对本EY Oversight项目左栏的组织结构图中的所选实体，点击此处下载详细的客户请求信息。",
	projectInfo: "项目信息",
	exportDate: "导出日期",
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: "请求项编号",
	requestTitle: "请求标题",
	priority: "优先级",
	status: labels.status,
	receivedDate: "接收日期",
	dueDate: "截止日期",
	overdue: labels.overdueLabel,
	eyContact: "安永联系人",
	assignedTo: "被分配人",
	statusLabels: [{
		id: 1,
		label: "草稿"
	},
	{
		id: 2,
		label: "无客户联系人"
	},
	{
		id: 3,
		label: "已发送"
	},
	{
		id: 4,
		label: "系统错误"
	},
	{
		id: 5,
		label: "无效客户联系人"
	},
	{
		id: 6,
		label: "待回复"
	},
	{
		id: 7,
		label: "已接收"
	},
	{
		id: 8,
		label: "已接受"
	},
	{
		id: 9,
		label: "已退回"
	},
	{
		id: 10,
		label: "已撤销"
	},
	{
		id: 11,
		label: "发送中"
	},
	{
		id: 12,
		label: "接受中"
	},
	{
		id: 13,
		label: "撤销中"
	},
	{
		id: 14,
		label: "删除中"
	},
	{
		id: 15,
		label: "退回中"
	},
	{
		id: 16,
		label: "回复中"
	},
	{
		id: 17,
		label: "已删除"
	},
	{
		id: 18,
		label: "已退回无效客户联系人"
	},
	{
		id: 19,
		label: "召回中"
	},
	{
		id: 20,
		label: "已召回"
	},
	{
		id: 21,
		label: "完成中"
	},
	{
		id: 22,
		label: "召回中"
	}
	],
	priorityTypeLabels: [{
		id: 1,
		label: "低"
	}, {
		id: 2,
		label: "中等"
	}, {
		id: 3,
		label: "高"
	}, {
		id: 4,
		label: "严重"
	}],

	risks: {
		exportButtonTitle: "针对本EY Oversight项目左栏的组织结构图中的所选实体，点击此处下载详细的风险评估数据。",
		tabTitle: "风险评估详情",
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: "账户/披露名称",
			pspIndex: "主要实质性程序索引",
			accountType: "指定",
			assertion: "认定",
			inherentRisk: "固有风险",
			controlRisk: "控制风险",
			craValue: "控制风险评估",
			riskType: "风险类型",
			riskName: "风险名称",
			relatedTasks: "关联的任务",
			taskStatus: "任务状态"
		}
	},
	exportButtonTooltip: "点击此处下载主审小组和相关组成部分项目小组的详细调节数据。",
	primaryTeamEngagementName: "主审小组项目名称",
	componentTeamEngagementName: "组成部分项目小组项目名称",
	howToUseThisExport: "如何使用此导出:",
	howToUseThisExportText: "待定-如何使用此导出文本",
	reconciliationComponentExportTabTitle: "账户",
	reconciliationComponentExport: {
		status: "状态",
		primaryTeamAccountName: "主审小组账户名称",
		componentTeamAccountNames: "组成部分项目小组账户名称",
		pspIndexes: "主要实质性程序索引",
		designation: "指定",
		c: "完整性",
		eo: "存在性/发生",
		mv: "计量/计价",
		ro: "权利和义务",
		pd: "列报和揭露",
		comment: "批注"
	},
	groupRiskStatusLabels: {
		[groupRiskStatus.open]: "未完成",
		[groupRiskStatus.assessed]: "已评估",
		[groupRiskStatus.mapped]: "已對應",
		[groupRiskStatus.unmapped]: "未對應",
		[groupRiskStatus.notApplicable]: "不适用"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: "状态",
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: "完整性",
		eo: "存在性/发生",
		mv: "计量/计价",
		ro: "权利和义务",
		pd: "列报和揭露",
		comment: "'批注'"
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: "特别",
	[accountDesignations.limitedRiskAccount]: "有限风险",
	[accountDesignations.insignificantAccount]: "不重大",
	[accountDesignations.otherAccount]: "其他",
	[accountDesignations.significantDisclosure]: "重大披露"
}

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
}
